import Column from "@/Components/Grid/Column";
import Row from "@/Components/Grid/Row";
import sanitizeHTML from "@/Helpers/sanitizeHTML";
import FrontText from "../../FrontText";

const AcfFeaturesList = ({ list, blockSpacing = 'xl:my-c120 lg:my-20 md:my-15 my-10' }) => {
    return (
        <Column className={`${blockSpacing}`}>
            <Row className='md:gap-y-10 gap-y-5'>
                {list.map((el, id) => (
                    <Column xl={6} lg={6} md={6} key={`acfFeaturesList_${id}`}>
                        <div className="inner-wrapper flex">
                            <div className="shrink-0 md:mr-3 mr-1 md:w-12 w-11">
                                <FrontText
                                    textSize="38/46-m-32/44"
                                    className="text-heading-blue font-semibold"
                                >
                                    <span>
                                        {(id + 1).toLocaleString("en-US", {
                                            minimumIntegerDigits: 2,
                                        })}
                                    </span>
                                </FrontText>
                            </div>

                            <div className="mt-4">
                                <FrontText textSize='20/24' className="mb-1 text-heading-blue font-semibold">
                                    {sanitizeHTML(el.title)}
                                </FrontText>
                                <FrontText textSize='16/20' className="text-standard-black">
                                    {sanitizeHTML(el.description)}
                                </FrontText>
                            </div>
                        </div>
                    </Column>
                ))}
            </Row>
        </Column>
    );
};

export default AcfFeaturesList;
